import {
  CreatorappCampaignWeekUserEligibilityState as EligibilityState,
  CreatorappWalletState,
} from "evangelist-db-schema/api";
import type { CampaignListItem } from "~/common/Types";

export function shouldShowWalletInviteLock(
  campaign: CampaignListItem,
): boolean {
  if (!campaign.requiresWalletVerification) {
    return false;
  }

  return [EligibilityState.Pending, EligibilityState.Ineligible].includes(
    campaign.eligibilityState,
  );
}

export function resolveWalletConnectorLabel({
  campaign,
  lastNonEligibleWalletAddress,
}: {
  campaign: CampaignListItem | null | undefined;
  lastNonEligibleWalletAddress: string | null;
}): string {
  if (lastNonEligibleWalletAddress) {
    return "Try another wallet";
  }

  if (campaign?.requiresWalletVerification) {
    return "Connect invited wallet";
  }

  return "Connect Wallet";
}

export type WalletInviteStatus =
  | { kind: "eligible"; label: string }
  | { kind: "needsVerification"; label: string }
  | { kind: "awaitingEligibility"; label: string }
  | { kind: "notInvited"; label: string };

export function resolveWalletInviteStatus({
  isEligible,
  walletState,
  isInvited,
}: {
  isEligible: boolean;
  walletState: CreatorappWalletState;
  isInvited?: boolean;
}): WalletInviteStatus {
  if (isEligible) {
    return { kind: "eligible", label: "Eligible for reward" };
  }

  // If wallet is not invited, show not eligible message
  if (isInvited === false) {
    return { kind: "notInvited", label: "Not invited" };
  }

  if (walletState === CreatorappWalletState.Verified) {
    return { kind: "awaitingEligibility", label: "Eligibility refreshing" };
  }

  return { kind: "needsVerification", label: "Needs verification" };
}
